// extracted by mini-css-extract-plugin
export default {"dcuiThemingCompletePage":"dcui-theming-complete-page__dcui-theming-complete-page__cuNLD"};